




import { defineComponent } from '@vue/composition-api';

import PanelWithNotifyGroupEditor from '@/components/Setting/PanelWithNotifyGroupEditor.vue';

const Edit = defineComponent({
  props: {
    initRole: {},
  },
  components: {
    PanelWithNotifyGroupEditor,
  },
  // setup() {},
});

export default Edit;
